import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock, XCircle, Loader2 } from "lucide-react";
import { api, brl } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const tx = params.get("tx");
  const cancelled = params.get("cancelado");
  const { refreshUser } = useAuth();
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!tx || cancelled) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${tx}`);
        setInfo(data);
        if (data.payment_status === "paid") {
          setState("paid");
          refreshUser();
          return;
        }
        if (data.payment_status === "expired") return setState("failed");
      } catch {
        return setState("failed");
      }
      tries += 1;
      if (tries >= 10) return setState("pending");
      timer = setTimeout(poll, 2500);
    };
    poll();
    return () => clearTimeout(timer);
  }, [tx, cancelled, refreshUser]);

  const view = {
    checking: { icon: Loader2, color: "text-cyan-300", title: "Confirmando pagamento", spin: true, text: "Aguarde alguns segundos..." },
    paid: { icon: CheckCircle2, color: "text-lime-300", title: "Pagamento aprovado", text: info?.credits ? `${info.credits} crédito(s) de foto adicionados à sua conta.` : "Inscrição liberada! Agora envie sua foto." },
    pending: { icon: Clock, color: "text-yellow-300", title: "Pagamento pendente", text: "Assim que for confirmado (ex: Pix ou boleto), seus créditos serão liberados." },
    cancelled: { icon: XCircle, color: "text-red-400", title: "Pagamento cancelado", text: "Nenhuma cobrança foi feita." },
    failed: { icon: XCircle, color: "text-red-400", title: "Não foi possível confirmar", text: "Verifique seu painel em instantes." },
  }[state];
  const Icon = view.icon;

  return (
    <div className="grid-bg flex min-h-[70vh] items-center justify-center px-5 py-16" data-testid="payment-return-page">
      <div className="glass w-full max-w-md rounded-2xl p-10 text-center">
        <Icon className={`mx-auto h-14 w-14 ${view.color} ${view.spin ? "animate-spin" : ""}`} />
        <h1 className="mt-5 font-display text-4xl font-black uppercase" data-testid="payment-status-title">{view.title}</h1>
        {info && <p className="mt-2 font-mono-tech text-xs text-slate-400">{info.description} · {brl(info.amount)}</p>}
        <p className="mt-4 text-slate-300">{view.text}</p>
        <Link to="/painel" data-testid="payment-go-dashboard" className="btn-neon mt-8 inline-block rounded-full px-7 py-3 font-semibold">Ir para meu painel</Link>
      </div>
    </div>
  );
}
